module.exports = __webpack_public_path__ + "static/media/circle-empty-blue.972b18f0.svg";